export const projectFilterIconStyle = {
    border: "1px solid",
    borderColor: "divider",
    borderRadius: "4px",
    width: 30,
    height: 30,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
};

export const projectInfoIconStyle = {
    display: "flex",
    bgcolor: "background.paper",
    backdropFilter: "blur(25px)",
    width: 30,
    height: 30,
    fontSize: 20,
    borderRadius: "5px",
    justifyContent: "center",
    alignItems: "center",
};

export const projectPrintItemStyle = {
    py: 1,
    mb: 0.5,
    borderBottom: "1px solid ",
    borderTop: "1px solid ",
    borderColor: "black",
    boxSizing: "borderBox",
    display: "flex",
    flexDirection: "column",
    fontSize: "14px",
};

export const projectCheckboxContainerStyle = {
    width: 35,
    height: 35,
    bgcolor: "background.paper",
    borderRadius: "17.5px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
};

export function getProjectBatchActionsStyle(mode: string) {
    return {
        position: "fixed",
        width: 280,
        bottom: 24,
        right: 24,
        bgcolor:
            mode === "dark" ? "rgba(25,25,25,0.7)" : "rgba(225,225,225,0.6)",
        backdropFilter: "blur(30px)",
        p: 1.5,
        borderRadius: "12px",
        boxShadow: "0 2px 12px rgba(0,0,0,0.5)",
        zIndex: 99,
    };
}

export const projectBatchActionButtonStyle = {
    width: 80,
    height: 65,
    border: "1px solid",
    borderColor: "divider",
    bgcolor: "background.paper",
    borderRadius: "8px",
    cursor: "pointer",
    "&:hover": { bgcolor: "background.default" },
};
